import * as React from "react";
import useLocalStorage from "../hooks/useLocalstorage";
import config from "../config";
import { useSelector } from "react-redux";
import { useBilling } from "../components/Kitchen/billingProvider";

const DraftContext = React.createContext();

const BillingDraftProvider = ({ children, ...props }) => {
  const [draftBill, setDraftBill] = useLocalStorage("billingDraft", []);
  const [draftBillCatch, setDraftBillCatch] = useLocalStorage(
    "billingDraftCatch",
    []
  );
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const employeeId = useSelector((state) => state.shopDetails.empId);
  const {
    state: { b2bBill = false },
  } = useBilling();

  const [draftBillForB2b, setDraftBillB2b] = useLocalStorage(
    "B2bBillingDraft",
    []
  );
  const value = [
    draftBill,
    setDraftBill,
    draftBillForB2b,
    setDraftBillB2b,
    draftBillCatch,
    setDraftBillCatch,
  ];

  React.useEffect(() => {
    (async function (shopId, employeeId) {
      const getDraft = async () => {
        try {
          const res = await fetch(`${config.newApiGateway}/draft/draft`, {
            method: "POST",
            body: JSON.stringify({
              action: "getDraft",
              shopId: shopId,
              employeeId: employeeId ? employeeId : "",
              shopTypeandCustomertype: b2bBill ? "draft-b2b" : "draft",
            }),
            headers: {
              "x-api-key": `${config.newApiKey}`,
              "Content-Type": "application/json",
            },
          });
          const data = await res.json();

          if (data.status === "SUCCESS") {
            if (b2bBill) {
              setDraftBillB2b(data.data);
            } else {
              setDraftBill(data.data);
            }
          }
        } catch (error) {
          console.log("getRestaurantDraftError", error);
        }
      };
      getDraft();
    })(shopId, employeeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, employeeId]);

  return (
    <DraftContext.Provider value={value} {...props}>
      {children}
    </DraftContext.Provider>
  );
};

export default BillingDraftProvider;

export const useBillingDraft = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(
      `useBillingDraft must be used within a BillingDraftProvider`
    );
  }
  return context;
};

export const useBillingDraftForB2b = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(
      `useBillingDraftForB2b must be used within a BillingDraftProvider`
    );
  }
  return [context[2], context[3]];
};

export const useBillingDraftWithCatch = () => {
  const context = React.useContext(DraftContext);
  if (context === undefined) {
    throw new Error(
      `useBillingDraftWithCatch must be used within a BillingDraftProvider`
    );
  }
  return [context[4], context[5]];
};
